import { useState } from 'react'
import { customerData, CustomerReceiptData, CustomerShippoLabel, CustomerShippoReceiptData } from '../../../../utilities/CustomerData'
import { refreshAccessToken, shouldShowDocuments, showCollectionsWindow } from '../../../../utilities/extensions'
import { useNavigate } from 'react-router-dom'
import { RefundCalculatedWindow } from '../../../Payment/RefundCalculatedWindow'
import { PaymentCenter } from '../../../Payment/PaymentCenter'
import { DashboardTracking } from './DashboardTracking'
import { apiURL } from '../../../../utilities/URLs'

export default function DashboardDocumentsCenter() {
  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState(0)
  const [tosLink, setTOSLink] = useState(customerData.customerTOSData.tosLinkURL)
  const [plaidLink, setPlaidLink] = useState(customerData.customerPlaidAgreement.customerLink)
  const [invoiceLink, setInvoiceLink] = useState(customerData.customerInvoiceData.invoiceLinkURL)
  const [receiptLinks, setReceiptLinks] = useState(customerData.customerReceipts)
  const [shippoReceiptLinks, setShippoReceiptLinks] = useState(customerData.customerShippoReceipts)
  const [checkingInvoiceInfo, setCheckingInvoiceInfo] = useState(false)
  const [isCollections, setIsCollections] = useState(showCollectionsWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))

  const [selectedYear, setSelectedYear] = useState(null)
  const showDocuments = shouldShowDocuments(customerData.customerStageHistory.find(stage => stage.currentStage === true))

  const handlePrintDocument = async (link) => {
    const printWindow = await handleDownloadS3Link(link)
    printWindow.addEventListener('load', () => {
      printWindow.print()
    })
  }

  const handleShowInvoice = async () => {
    if (customerData.customerInvoiceData.invoiceLinkURL.length === 0)
      setActiveTab(1)
    else
      await handleDownloadS3Link(customerData.customerInvoiceData.invoiceLinkURL)
  }

  const handleDownloadS3Link = async (linkURL) => {
    const s3UrlResponse = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(linkURL)}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const s3UrlData = await s3UrlResponse.json()
    if (s3UrlData.response.error) {
      if (s3UrlData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleDownloadS3Link(linkURL) : navigate('/', { state: { expired: true } })
      } else
        console.error(s3UrlData.response.error)
    } else
      return window.innerWidth <= 768 ? window.location.href = s3UrlData.response.s3Url : window.open(s3UrlData.response.s3Url, '_blank')
  }

  return (
    <>
      {activeTab === 0 ? (
        <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-white mb-10'>
          <p className='font-bold text-xl mb-4'>SETC Pros Client Agreement</p>
          {tosLink.length > 0 ? (
            <div className='flex gap-4'>
              <button onClick={() => handleDownloadS3Link(tosLink)} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                View Document
              </button>
              <button onClick={() => handlePrintDocument(customerData.customerTOSData.tosLinkURL)} className='rounded-md bg-secondaryColor hover:bg-secondaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                Print Document
              </button>
            </div>
          ) : (
            <p className='font-bold text-gray-500 -mt-4 mb-4'>No Agreement Available Yet.</p>
          )}
          <p className='font-bold text-xl mb-4'>SETC Pros ACH Authorization Form</p>
          {plaidLink.length > 0 ? (
            <div className='flex gap-4'>
              <button onClick={() => handleDownloadS3Link(plaidLink)} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                View Document
              </button>
              <button onClick={() => handlePrintDocument(plaidLink)} className='rounded-md bg-secondaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                Print Document
              </button>
            </div>
          ) : (
            <p className='font-bold text-gray-500 -mt-4 mb-4'>No Authorization Form Available Yet.</p>
          )}
          <p className='font-bold text-xl mb-4'>Invoice:</p>
          {(invoiceLink.length > 0 && !customerData.customerAdvanceFunding.applicationId && customerData.customerLeadData.leadStage.leadStageId !== 'de9f6d4a-0aff-4b68-9a87-7a42ae371a61') ? (
            <div>
              <div className='flex gap-4'>
                <button onClick={() => handleShowInvoice()} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                  View Invoice
                </button>
                <button onClick={() => handlePrintDocument(invoiceLink)} className='rounded-md bg-secondaryColor hover:bg-secondaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                  Print Invoice
                </button>
              </div>
              {customerData.customerInvoiceData.invoiceTerms === 'Invoice Due in 90 Days' ? (
                customerData.customerInvoiceData.customerVaultId.length === 0 && customerData.customerInvoiceData.plaidAccessToken.length === 0 ? (
                  <button onClick={() => navigate('/addPaymentMethod')} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-44 mb-4'>
                    Add Payment Method
                  </button>
                ) : (
                  !customerData.customerInvoiceData.invoicePaid && (
                    <>
                      <button onClick={() => navigate('/paymentPortal', { state: { isCollections: isCollections } })} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                        Pay Invoice
                      </button>
                      {checkingInvoiceInfo && (
                        <div className='flex flex-row items-center justify-center gap-2'>
                          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
                          <p>Checking Invoice Info...</p>
                        </div>
                      )}
                    </>
                  )
                )
              ) : (
                !customerData.customerInvoiceData.invoicePaid && (
                  <div className='flex gap-4'>
                    <button onClick={() => navigate('/paymentPortal', { state: { isCollections: isCollections } })} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                      Pay Invoice
                    </button>
                    {checkingInvoiceInfo && (
                      <div className='flex flex-row items-center justify-center gap-2'>
                        <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
                        <p>Checking Invoice Info...</p>
                      </div>
                    )}
                  </div>
                )
              )}
            </div>
          ) : (
            <p className='font-bold text-gray-500 -mt-4 mb-4'>No Invoice Available Yet.</p>
          )}
          <p className='font-bold text-xl mb-4'>Receipt(s):</p>
          {receiptLinks.length > 0 ? (
            <div>
              {receiptLinks.map((_receiptLink, index) => {
                const receiptLink = new CustomerReceiptData(_receiptLink)
                return (
                  <div className='flex flex-col items-start'>
                    <p className='font-bold'>Receipt {receiptLink.receiptNumber}</p>
                    <div className='flex gap-4'>
                      <button onClick={() => handleDownloadS3Link(receiptLink.receiptLinkURL)} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                        View Receipt
                      </button>
                      <button onClick={() => handlePrintDocument(receiptLink.receiptLinkURL)} className='rounded-md bg-secondaryColor hover:bg-secondaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                        Print Receipt
                      </button>
                    </div>
                  </div>
                )
              })}
              {shippoReceiptLinks.map((_receiptLink, index) => {
                const receiptLink = new CustomerShippoReceiptData(_receiptLink)
                return (
                  <div className='flex flex-col items-start'>
                    <p className='font-bold'>Receipt {receiptLink.receiptNumber}</p>
                    <div className='flex gap-4'>
                      <button onClick={() => handleDownloadS3Link(receiptLink.receiptLinkURL)} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                        View Receipt
                      </button>
                      <button onClick={() => handlePrintDocument(receiptLink.receiptLinkURL)} className='rounded-md bg-secondaryColor hover:bg-secondaryDarkColor transition duration-200 text-white h-10 w-40 mb-4'>
                        Print Receipt
                      </button>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <p className='font-bold text-gray-500 -mt-4 mb-4'>No Receipts Available Yet.</p>
          )}
          <p className='font-bold text-xl mb-4'>Shippo Label(s):</p>
          {customerData.customerShippoLabels.length > 0 ? (
            customerData.customerShippoLabels.map((_label, index) => {
              const label = new CustomerShippoLabel(_label)
              return (
                <div className='rounded-md shadow-md p-6 flex flex-col items-center w-fit'>
                  {label.providerImageURL && (
                    <img src={label.providerImageURL} alt={`${label.provider} logo`} className='w-16 h-16 mb-6 object-contain' />
                  )}
                  <p className='text-xl font-semibold text-gray-800 mb-2'>{customerData.customerShippoTrackingData.provider}</p>
                  <p className='text-sm text-gray-600 mb-6'><span className='font-medium'>Tracking Number:</span> {label.trackingNumber}</p>
                  <p className='text-sm text-gray-600 mb-6'><span className='font-medium'>Tracking Status:</span> {label.trackingStatus}</p>
                  <button onClick={() => window.innerWidth <= 768 ? window.location.href = label.trackingURL : window.open(label.trackingURL, '_blank')} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white py-2 px-6 w-full mb-4'>
                    View Tracking
                  </button>
                  <button onClick={() => window.innerWidth <= 768 ? window.location.href = label.labelURL : window.open(label.labelURL, '_blank')} className='rounded-md bg-secondaryColor hover:bg-secondaryDarkColor transition duration-200 text-white py-2 px-6 w-full'>
                    View Label
                  </button>
                </div>
              )
            })
          ) : (
            <p className='font-bold text-gray-500 -mt-4 mb-4'>No Labels Yet.</p>
          )}
          <p className='font-bold text-xl mb-4 mt-4'>Tax Documents:</p>
          {showDocuments ? (
            <>
              <p className='font-bold text-gray-500 mb-4 flex items-center'>
                2020 Tax Document:
                {customerData.customerDocuments.taxDocument2020.length > 0 ? (
                  <button onClick={() => setSelectedYear(2020)} className='rounded-md bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white h-10 w-40 ml-1'>
                    View Document
                  </button>
                ) : (
                  <p className='font-bold text-gray-500 ml-1'>No Documents Found.</p>
                )}
              </p>
              <p className='font-bold text-gray-500 flex items-center'>
                2021 Tax Document:
                {customerData.customerDocuments.taxDocument2021.length > 0 ? (
                  <button onClick={() => customerData.customerDocuments.taxDocument2021UF.length > 0 ? navigate('/downloadDocument') : setSelectedYear(2021)} className='rounded-md bg-secondaryColor hover:bg-secondaryDarkColor transition duration-200 text-white h-10 w-40 ml-1'>
                    {customerData.customerDocuments.taxDocument2021UF.length > 0 ? 'Download Now' : 'View Document'}
                  </button>
                ) : (
                  <p className='font-bold text-gray-500 ml-1'>No Documents Found.</p>
                )}
              </p>
              {selectedYear && (
                <iframe src={customerData.customerDocuments[`taxDocument${selectedYear}`]} width={'100%'} height={'1000px'}></iframe>
              )}
            </>
          ) : (
            <p className='font-bold text-gray-500 -mt-4 mb-4'>No Documents Available Yet.</p>
          )}

          <DashboardTracking />
        </div>
      ) : activeTab === 1 ? (
        <RefundCalculatedWindow />
      ) : (
        <PaymentCenter />
      )}
    </>
  )
}

/**
 * 
 */